import axios from 'axios';
import { apiUrl } from '@qwealth/qdata';
import { responseListMapper } from '@qwealth/qcore';
import { EntitySecurityMaster } from '../types';

export const loadSecurityMaster = async (ticker: string) =>
  await axios
    .get(`${apiUrl}/securityMaster?ticker[like]=${ticker}`)
    .then(response => responseListMapper<EntitySecurityMaster>(response));
